export default __webpack_public_path__ + "static/media/Ellipse 23.ca229a17.png";